// class CartRemoveButton extends HTMLElement {
//   constructor() {
//     super();

//     this.addEventListener('click', (event) => {
//       event.preventDefault();
//       const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
//       cartItems.updateQuantity(this.dataset.index, 0);
// console.log('asasasas')
//  const cartIcon = document.querySelector("#cart-icon-bubble");
//       setTimeout(function(){
//         jQuery.getJSON('/cart.js', function(cart) {
//         console.log('item-counts',cart.item_count);
//         if (cart.item_count == 0) {
//           console.log('cart.item_count',cart.item_count)
//           cartIcon.setAttribute("cart-item", "empty");
//         }
//         });
//       },1000)

//     });
//   }
// }

// customElements.define('cart-remove-button', CartRemoveButton);

// class CartRemoveButton extends HTMLElement {
//   constructor() {
//     super();
//     const toggleScrollArrow = () => {
//       const cartItemCount = document.querySelectorAll(".list_products_cart .cart-item").length; 
//       console.log("Number of cart items:", cartItemCount);
//       const scrollArrow = document.querySelector(".scroll_down_arrow_mobile");
//       if (scrollArrow) {
//         if (cartItemCount > 3) {
//           scrollArrow.style.display = "block";
//         } else {
//           scrollArrow.style.display = "none";
//         }
//       }
//     };
//     toggleScrollArrow();
//     this.addEventListener("click", (event) => {
//       event.preventDefault();
//       const cartItems = this.closest("cart-items") || this.closest("cart-drawer-items");
//       if (cartItems) {
//         cartItems.updateQuantity(this.dataset.index, 0);
//         setTimeout(() => {
//           toggleScrollArrow();
//         }, 300); 
//       }
//     });
//   }
// }
// customElements.define("cart-remove-button", CartRemoveButton);

class CartRemoveButton extends HTMLElement {
  constructor() {
    super();   

    const toggleScrollArrow = () => {
      const cartItemCount = document.querySelectorAll(".list_products_cart .cart-item").length; 
      console.log("Number of cart items:", cartItemCount);
      const scrollArrow = document.querySelector(".scroll_down_arrow_mobile");
      if (scrollArrow) {
        if (cartItemCount > 3) {
          scrollArrow.style.display = "block";
        } else {
          scrollArrow.style.display = "none";
        }
      }

      // Get the cart icon and update the cart-item attribute immediately
      const cartIcon = document.querySelector("#cart-icon-bubble");
      if (cartIcon) {
        setTimeout(function(){
        jQuery.getJSON('/cart.js', function(cart) {
        console.log('item-counts',cart.item_count);
        if (cart.item_count == 0) {
          console.log('cart.item_count',cart.item_count)
          cartIcon.setAttribute("cart-item", "empty");
        }else{
          cartIcon.setAttribute("cart-item", "added");
        }
        });
      },10)
      }
    };

    // Initial check on page load or component creation
    toggleScrollArrow(); 

    // Handle click event on remove button
    this.addEventListener("click", (event) => {
      event.preventDefault();
      const cartItems = this.closest("cart-items") || this.closest("cart-drawer-items");
      if (cartItems) {
        // Assuming `updateQuantity` removes the item or sets quantity to 0
        cartItems.updateQuantity(this.dataset.index, 0);

        // Immediately update the cart state and arrow visibility
        toggleScrollArrow(); 
      }
    });
  }
}

customElements.define("cart-remove-button", CartRemoveButton);





class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      this.onCartUpdate(event);
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  resetQuantityInput(id) {
    const input = this.querySelector(`#Quantity-${id}`);
    input.value = input.getAttribute('value');
    this.isEnterPressed = false;
  }

  setValidity(event, index, message) {
    event.target.setCustomValidity(message);
    event.target.reportValidity();
    this.resetQuantityInput(index);
    event.target.select();
  }

  validateQuantity(event) {
    const inputValue = parseInt(event.target.value);
    const index = event.target.dataset.index;
    let message = '';

    if (inputValue < event.target.dataset.min) {
      message = window.quickOrderListStrings.min_error.replace('[min]', event.target.dataset.min);
    } else if (inputValue > parseInt(event.target.max)) {
      message = window.quickOrderListStrings.max_error.replace('[max]', event.target.max);
    } else if (inputValue % parseInt(event.target.step) !== 0) {
      message = window.quickOrderListStrings.step_error.replace('[step]', event.target.step);
    }

    if (message) {
      this.setValidity(event, index, message);
    } else {
      event.target.setCustomValidity('');
      event.target.reportValidity();
      this.updateQuantity(
        index,
        inputValue,
        document.activeElement.getAttribute('name'),
        event.target.dataset.quantityVariantId
      );
    }
  }

  onChange(event) {
    this.validateQuantity(event);
  }

  
  // onCartUpdate(eventt) {
  //   // console.log(eventt)
  //   function toggleScrollArrow() {
  //   const cartItemCount = $(".list_products_cart .cart-item").length; // Count the rows within the table
  //   console.log("Number of cart items:", cartItemCount);
    
  //   if (cartItemCount > 3) {
  //     $(".scroll_down_arrow_mobile").show();
  //   } else {
  //     $(".scroll_down_arrow_mobile").hide();
  //   }
  // }
  
  // toggleScrollArrow();
  //   if (this.tagName === 'CART-DRAWER-ITEMS') {
  //     fetch(`${routes.cart_url}?section_id=cart-drawer`).then((response) => response.text()).then((responseText) => {
  //         const html = new DOMParser().parseFromString(responseText, 'text/html');
  //         const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
  //         for (const selector of selectors) {
  //           const targetElement = document.querySelector(selector);
  //           const sourceElement = html.querySelector(selector);
  //           if (targetElement && sourceElement) {
  //             targetElement.replaceWith(sourceElement);
  //           }
  //         }
  //       })
  //       .catch((e) => {
  //         console.error(e);
  //       });
  //   } else {
  //     fetch(`${routes.cart_url}?section_id=main-cart-items`)
  //       .then((response) => response.text())
  //       .then((responseText) => {
  //         const html = new DOMParser().parseFromString(responseText, 'text/html');
  //         const sourceQty = html.querySelector('cart-items');
  //         this.innerHTML = sourceQty.innerHTML;
  //       })
  //       .catch((e) => {
  //         console.error(e);
  //       });
  //   }
  // }



  //new cartupdate

onCartUpdate(event) {
  // Function to toggle scroll arrow visibility based on item count
  function toggleScrollArrow() {
    const cartItemCount = document.querySelectorAll(".list_products_cart .cart-item").length;
    console.log("Number of cart items:", cartItemCount); // Log the number of items
    const scrollArrow = document.querySelector(".scroll_down_arrow_mobile");
    if (scrollArrow) {
      if (cartItemCount > 3) {
        scrollArrow.style.display = "block";
      } else {
        scrollArrow.style.display = "none";
      }
    }

    // Set cart-item attribute based on cart content
    const cartIcon = document.querySelector("#cart-icon-bubble");
    if (cartIcon) {
      if (cartItemCount > 0) {
        cartIcon.setAttribute("cart-item", "added");
      } else {
        cartIcon.setAttribute("cart-item", "empty");
      }
    }
  }

  toggleScrollArrow(); // Call the function to toggle arrow and update cart status

  if (this.tagName === "CART-DRAWER-ITEMS") {
    // Update cart drawer items if event comes from the cart drawer
    fetch(`${routes.cart_url}?section_id=cart-drawer`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, "text/html");
        const selectors = ["cart-drawer-items", ".cart-drawer__footer" ,".v-modal-incentives"];
        for (const selector of selectors) {
          const targetElement = document.querySelector(selector);
          const sourceElement = html.querySelector(selector);
          if (targetElement && sourceElement) {
            targetElement.replaceWith(sourceElement);
          }
        }
        toggleScrollArrow(); // Update the cart and arrow visibility
      })
      .catch((e) => {
        console.error("Error updating cart drawer:", e);
      });
  } else {
    // Update main cart items if event comes from the main cart
    fetch(`${routes.cart_url}?section_id=main-cart-items`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, "text/html");
        const sourceQty = html.querySelector("cart-items");
        if (sourceQty) {
          this.innerHTML = sourceQty.innerHTML; // Update the cart items in the DOM
        }
        toggleScrollArrow(); // Update the cart and arrow visibility
      })
      .catch((e) => {
        console.error("Error updating main cart items:", e);
      });
  }
}



  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      },
    ];
  }

  updateQuantity(line, quantity, name, variantId) {
  
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        const quantityElement =
          document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll('.cart-item');

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute('value');
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });
        const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
        let message = '';
        if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
          if (typeof updatedValue === 'undefined') {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
          }
        }
        this.updateLiveRegions(line, message);

        const lineItem =
          document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
        }

        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });
      })
      .catch(() => {
        this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
      });
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').textContent = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'input',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}
